import React from "react";

/**
 * Renders a QR for the full referral URL. Uses a public QR image API so no extra
 * npm packages are required. For stricter privacy / offline use, replace with a
 * local generator (e.g. react-qr-code) after `npm install`.
 */
export const getIbReferralQrImageSrc = (data, px) => {
  const q = encodeURIComponent(data);
  return `https://api.qrserver.com/v1/create-qr-code/?size=${px}x${px}&margin=8&color=0c0c0d&bgcolor=ffffff&data=${q}`;
};

const IbReferralQRCode = ({ value, size = 176, className, title }) => {
  if (!value || !String(value).trim()) return null;
  const px = Math.max(64, Math.min(512, Math.round(size)));
  return (
    <img
      className={className}
      src={getIbReferralQrImageSrc(value, px)}
      alt={title || ""}
      title={title}
      width={px}
      height={px}
      loading="lazy"
      decoding="async"
    />
  );
};

export default IbReferralQRCode;
